
<div class="col-md-6 offset-md-3 mt-5">

  <div class="ng-container change-password-logo">
    <img src="assets/login-logo.png">
  </div>
  <div class="card">
    <h5 class="card-header">Entrarit - Change Password</h5>
    <div class="card-body">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="sr-only" for="password">Password</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
            </div>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="form-control py-0" name="password" id="password"  placeholder="Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.password.errors }" >
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary toggle-visibility-btn" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
              </button>
            </div>
            @if (submitted && f.password.errors) {
              <div class="invalid-feedback">
                @if (f.password.errors.required) {
                  <div>Password is required</div>
                }
              </div>
            }
            @if (f.password && f.password.errors?.pattern) {
              <div class="invalid-feedback">
                Password has to be 5 or more characters.
              </div>
            }
          </div>
        </div>
        <div class="form-group">
          <label class="sr-only" for="confirmPassword">Confirm Password</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
            </div>
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" class="form-control py-0" name="confirmPassword" id="confirmPassword"  placeholder="Confirm Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" >
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary toggle-visibility-btn" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'">
                <fa-icon [icon]="showConfirmPassword ? faEyeSlash : faEye"></fa-icon>
              </button>
            </div>
            @if (submitted && f.confirmPassword.errors) {
              <div class="invalid-feedback">
                @if (f.confirmPassword.errors.required) {
                  <div>Please confirm password</div>
                }
              </div>
            }
            @if (f.confirmPassword && f.confirmPassword.errors?.pattern) {
              <div class="invalid-feedback">
                Confirm Password has to be 5 or more characters.
              </div>
            }
            @if (submitted && f.confirmPassword.errors?.mustMatch) {
              <div class="invalid-feedback">
                Passwords do not match
              </div>
            }
          </div>
        </div>
        <button type="button" (click)="cancel()" class="btn btn-warning">
          Cancel  <fa-icon class="l-icon" [icon]="faHome"></fa-icon>
        </button>

        <button [disabled]="loading" class="btn btn-success float-right mx-2">
          @if (loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Submit <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
        </button>
      </form>
    </div>
  </div>
</div>

